import { IsOptional, IsString } from 'class-validator';

export class CreateEncounterContextDto {
  @IsOptional()
  @IsString()
  fhirReference?: string;
}

export class UpdateEncounterContextDto {
  @IsOptional()
  @IsString()
  fhirReference?: string;
}

export class EnsureEncounterContextDto {
  @IsString()
  fhirReference: string;
}
